<app-langding-page-nav-bar></app-langding-page-nav-bar>

<div class="content">
  <div class="row" style="margin-top: 38px">
    <div class="col-sm-9">
      <p>Fields marked with <span class="text-danger">*</span> are mandatory!</p>
      <form formValues [formGroup]="businessForm" formName="businessForm" class="app-form form-horizontal">
        <div class="hpanel gs-card">
          <div class="panel-heading gs-card-headerhbuilt">
            <!-- <h5 class="font-light m-b-xs" >
                            Business Details
                        </h5> -->
            <!-- <label class="control-label padding-top-0 margin-bottom-5 margin-top-5">Business Details</label> -->
            Business Details
          </div>
          <div class="panel-body gs-card-bodygs-card-body">
            <div>
              <div class="form-group row" style="margin-bottom: 4px">
                <div class="col-sm-3" style="padding-left: 54px" *ngIf="photoId != undefined || photoId != null">
                  <img class="img-circle" height="90px" width="90px" [src]="img.src" />
                </div>
                <div style="padding-left: 54px" class="col-sm-3" *ngIf="photoId == undefined || photoId == null">
                  <img class="img-circle" height="90px" width="90px" src="assets/images/gallery/company.png" />
                </div>
                <div class="col-sm-8">
                  <label for="industryClassification" class="
                      margin-bottom-5
                      control-label
                      required-field
                      font-light
                    ">Industry Classification</label>
                  <select class="form-control input-sm" formControlName="industryClassification"
                    (change)="onChangeIndustry($event.target.value)">
                    <option value="null" selected disabled>
                      Industry Classification
                    </option>
                    <option *ngFor="let industry of industryType" [value]="industry">
                      {{ industry }}
                    </option>
                  </select>
                  <div *ngIf="
                      (submit && userControl.industryClassification.invalid) ||
                      (userControl.industryClassification.invalid &&
                        (userControl.industryClassification.dirty ||
                          userControl.industryClassification.touched))
                    " class="error-msg">
                    <div *ngIf="userControl.industryClassification.errors.required">
                      Please select a valid industry classification
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row" *ngIf="otherFlag">
                <label for="others" class="col-sm-3 control-label required-field font-light">Other</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control input-sm" placeholder="Other Industry Classification"
                    formControlName="others" trim="blur" />
                </div>
                <div *ngIf="
                    (submit && userControl.others.invalid) ||
                    (userControl.others.invalid &&
                      (userControl.others.dirty || userControl.others.touched))
                  " class="error-msg" style="margin-top: 30px; margin-right: 70px">
                  <div *ngIf="userControl.others.errors.required">
                    Other field is required
                  </div>
                </div>
              </div>

              <!-- <div class="form-group row">
                <label for="npiNo" class="col-sm-3 control-label font-light">NPI Number</label>
                <div class="col-sm-8">
                  <input id="businessNpi" type="text" class="form-control input-sm" placeholder="NPI Number"
                    formControlName="npiNo" trim="blur" (keydown)="onEnterNpiNo($event)" (keyup)="onEnterNpiNo($event)"
                    (keypress)="filterNo($event)" />
                  <div *ngIf="userControl['npiNo'].hasError('incorrectNPI')" class="error-msg">
                    Invalid NPI number
                  </div>
                </div>
              </div> -->

              <div class="form-group row" *ngIf="hCareFlag">
                <label for="facilityPracticeType" class="col-sm-3 control-label required-field font-light">Facility /
                  Practice Type</label>
                <div class="col-sm-8" *ngIf="hCareFlag">
                  <!-- <input [typeahead]="facilityValue" [typeaheadMinLength]="0"
                                        class="form-control input-sm" placeholder="Facility / Practice Type"
                                        formControlName="facilityPracticeType"
                                        (typeaheadOnSelect)="onChngFacility($event)"> -->
                  <select (change)="onChngFacility($event.target.value)" class="form-control input-sm"
                    formControlName="facilityPracticeType">
                    <option [ngValue]="null" [disabled]="true">
                      Facility / Practice Type
                    </option>
                    <option [value]="facility" *ngFor="let facility of facilityValue">
                      {{ facility }}
                    </option>
                  </select>
                </div>
                <div style="margin-top: 30px; margin-right: 68px" *ngIf="
                    (submit && userControl.facilityPracticeType.invalid) ||
                    (userControl.facilityPracticeType.invalid &&
                      (userControl.facilityPracticeType.dirty ||
                        userControl.facilityPracticeType.touched))
                  " class="error-msg">
                  <div *ngIf="userControl.facilityPracticeType.errors.required">
                    Facility/ Practice Type is required
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="businessName" class="col-sm-3 control-label required-field font-light">Business Name</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control input-sm" placeholder="Business Name"
                    formControlName="businessName" disabled trim="blur" />
                </div>
              </div>

              <div class="form-group row">
                <label for="tagLine" class="col-sm-3 control-label font-light">Tag Line</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control input-sm" maxlength="141" trim="blur" placeholder="Tag Line"
                    formControlName="tagLine" (keypress)="checkSpace($event)" />
                  <div *ngIf="userControl.tagLine.invalid" class="error-msg">
                    <div *ngIf="userControl.tagLine.errors?.pattern">
                      {{FORMERROR.TAGLINE_PATTERN}}
                    </div>
                    <div *ngIf="userControl.tagLine.errors?.maxword">
                      {{FORMERROR.TAGLINE_MAX}}
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="businessLogo" class="col-sm-3 control-label font-light">Logo</label>
                <div class="col-sm-8">
                  <ng-template #template>

                    <div class="modal-content">

                      <div class="common-header-flex">
                        <div>Logo</div>
                        <button>
                          <span class="common-close" (click)="modalclose()">&times;</span>
                        </button>
                      </div>

                      <div class="modal-body">
                        <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                          [aspectRatio]="1 / 1" format="jpeg" (imageCropped)="imageCropped($event)"
                          (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"></image-cropper>
                      </div>

                      <div class="custom-panel-footer">
                        <div class="panel-footer">
                          <div class="footer-flex">

                          </div>
                        </div>
                      </div>

                      <div class="modal-footer border--5">
                        <div>
                          <button class="btn btn-default" (click)="modalclose()">
                            Cancel
                          </button>
                          <button class="btn btn-primary" (click)="imageLoaded()">
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                  </ng-template>

                  <input type="file" class="form-control fs-file" accept=".jpg, .jpeg, .png"
                    (click)="myFileInput.value=''"
                    (change)="fileChangeEvent($event, template)" id="profileimage" #myFileInput
                    formControlName="businessLogo" />
                </div>
              </div>

              <div class="form-group row">
                <label for="companyType" class="col-sm-3 control-label required-field font-light">Company Type</label>
                <div class="col-sm-8">
                  <select class="form-control input-sm" formControlName="companyType">
                    <option [ngValue]="null" [disabled]="true">
                      Company Type
                    </option>
                    <option *ngFor="let company of companyTypeList">
                      {{ company }}
                    </option>
                  </select>
                  <div *ngIf="
                      (submit && userControl.companyType.invalid) ||
                      (userControl.companyType.invalid &&
                        (userControl.companyType.dirty ||
                          userControl.companyType.touched))
                    " class="error-msg">
                    <div *ngIf="userControl.companyType.errors.required">
                      Please select a valid Company Type
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="organizationType" class="col-sm-3 control-label required-field font-light">Organization
                  Type</label>
                <div class="col-sm-8">
                  <select type="text" class="form-control input-sm" formControlName="organizationType">
                    <option [ngValue]="null" [disabled]="true">
                      Organization Type
                    </option>
                    <option *ngFor="let organizationType of clientTypeList" [value]="organizationType">
                      {{ organizationType }}
                    </option>
                  </select>
                  <div *ngIf="
                  (submit && userControl.organizationType.invalid) ||
                  (userControl.organizationType.invalid &&
                    (userControl.organizationType.dirty ||
                      userControl.organizationType.touched))
                " class="error-msg">
                    <div *ngIf="userControl.organizationType.errors.required">
                      Organization Type is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="yearStarted" class="col-sm-3 control-label required-field font-light">Year Started</label>
                <div class="col-sm-8">
                  <select type="text" formControlName="yearStarted" class="form-control input-sm">
                    <option [ngValue]="null" [disabled]="true">
                      Year Started
                    </option>
                    <option *ngFor="let year of years" [value]="year">
                      {{ year }}
                    </option>
                  </select>
                  <div *ngIf="
                      (submit && userControl.yearStarted.invalid) ||
                      (userControl.yearStarted.invalid &&
                        (userControl.yearStarted.dirty ||
                          userControl.yearStarted.touched))
                    " class="error-msg">
                    <div *ngIf="userControl.yearStarted.errors.required">
                      Year is Required
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="companySize" class="col-sm-3 control-label required-field font-light">Company Size</label>
                <div class="col-sm-8">
                  <select type="text" formControlName="companySize" class="form-control input-sm">
                    <option [ngValue]="null" [disabled]="true">
                      Company Size
                    </option>
                    <option *ngFor="let size of companySize">{{ size }}</option>
                  </select>
                  <div *ngIf="
                      (submit && userControl.companySize.invalid) ||
                      (userControl.companySize.invalid &&
                        (userControl.companySize.dirty ||
                          userControl.companySize.touched))
                    " class="error-msg">
                    <div *ngIf="userControl.companySize.errors.required">
                      Company Size is required
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="form-group row">
                <label for="tags" class="col-sm-3 control-label font-light">
                  #Tags</label>
                <div class="col-sm-8">
                  <div >
                    <ng-select [addTag]="true" [multiple]="true" [isOpen]="false" maxSelectedItems="3"
                      addTagText="Add #Tag:" bindValue="label" [closeOnSelect]="true" [hideSelected]="true"
                      placeholder="Options to add 3 #tags only" [(ngModel)]="tagSelectedItems" formControlName="tags">
                    </ng-select>
                  </div>
                  <label><small>Press enter to give multiple #Tags </small></label>
                </div>
              </div> -->
            </div>
          </div>
        </div>

        <div class="hpanel gs-card">
          <div class="panel-heading gs-card-headerhbuilt">
            About Company
          </div>
          <div class="panel-body gs-card-bodygs-card-body">
            <div class="row">
              <div class="form-group R-summary">
                <div class="col-sm-11 business-note R-summary" style="margin-left: 20px">
                  <div trim="blur" formControlName="aboutCompany" id="aboutCompany" [ngxSummernote]="config2"></div>
                  <div class="text-danger">
                    <div *ngIf="businessForm.controls.aboutCompany.errors?.maxchar">
                      {{FORMERROR.ABOUT_YOURSELF_MAX}}
                    </div>
                    <div *ngIf="businessForm.controls.aboutCompany.errors?.minchar">
                      {{FORMERROR.ABOUT_YOUR_MIN}}
                    </div>

                  </div>
                  <div class="text-right" *ngIf="!businessForm.controls.aboutCompany.errors?.maxchar">
                    <label>
                      <small>
                        <span>{{remainingCharacters}}</span>
                       Characters remaining
                      </small>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="hpanel gs-card">
          <div class="panel-heading gs-card-headerhbuilt">
            <div>
              Location
            </div>
            <div class="panel-tools">
              <div class="row">
                <div id="create_business_add_location_button" class="col-sm-2" (click)="addLocation()">
                  <!-- <ng-icon name="tablerPlus" class="btn btn-xs btn-primary btn-circle" style="padding: 4px 5px; margin: -2px 16px" (click)="addLocation()"
                     title="Add location"></ng-icon> -->

                  <button class="edit-pencil gs-icon-btn">
                    <span>
                      <ng-icon name="tablerPlus" style="cursor: pointer; color: rgb(60,64,67) !important;font-size: 15px;"></ng-icon>
                    </span>
                  </button>

                </div>
              </div>
            </div>
            <!-- <label class="control-label padding-top-0 margin-bottom-5 margin-top-5">Location</label> -->
          </div>
          <div class="panel-body gs-card-bodygs-card-body">
            <div formArrayName="companyLocationDetails">
              <div *ngFor="
                  let work of locationArray.controls;
                  let i = index;
                  let lastItem = last
                ">
                <div [formGroupName]="i" class="form-horizontal">
                  <div class="form-group row">
                    <label for="address1" class="col-sm-3 control-label required-field font-normal">Address 1</label>
                    <div class="col-sm-8">
                      <input type="text" (keydown.enter)="$event.preventDefault()" formControlName="address1"
                        class="form-control input-sm" trim="blur" placeholder="Door No, Building Name, Street Name"
                        [ngClass]="{
                          'is-invalid':
                            submit && locationSubmit &&
                            getLocationFormgroup(i).controls['address1']
                              .invalid
                        }" />
                      <div *ngIf="
                          (submit && locationSubmit &&
                            getLocationFormgroup(i).controls['address1']
                              .hasError) ||
                          (getLocationFormgroup(i).controls['address1']
                            .hasError &&
                            (getLocationFormgroup(i).controls['address1']
                              .dirty ||
                              getLocationFormgroup(i).controls['address1']
                                .touched))
                        " class="error-msg">
                        <div *ngIf="
                            getLocationFormgroup(i).controls[
                              'address1'
                            ].hasError('required')
                          ">
                          Address 1 is required
                        </div>
                        <div *ngIf="
                            getLocationFormgroup(i).controls[
                              'address1'
                            ].hasError('minword')
                          ">
                          {{FORMERROR.BUSINESS_ADDRESS_MIN}}
                        </div>
                        <div *ngIf="
                            getLocationFormgroup(i).controls[
                              'address1'
                            ].hasError('maxword')
                          ">
                          {{FORMERROR.BUSINESS_ADDRESS_MAX}}
                        </div>

                      </div>
                    </div>
                    <div class="col-sm-1">
                      <div class="btn-group" style="margin-left: -13px" title="Remove location"
                        (click)="removeLocation(i)">
                        <button class="edit-pencil gs-icon-btn" type="button">
                          <span>
                            <ng-icon name="tablerTrash" style="
                                color: rgb(60,64,67) !important;font-size: 15px;
                              "></ng-icon>
                          </span>
                        </button>



                        <!-- <button class="edit-pencil gs-icon-btn">
                          <span>
                          <ng-icon name="tablerPlus" style="cursor: pointer; color: rgb(60,64,67) !important;font-size: 15px;"></ng-icon>
                        </span>
                      </button> -->

                      </div>



                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="address2" class="col-sm-3 control-label font-normal">Address 2</label>
                    <div class="col-sm-8">
                      <input type="text" (keydown.enter)="$event.preventDefault()" trim="blur"
                        class="form-control input-sm" placeholder="" formControlName="address2" />
                    </div>
                  </div>

                  <div class="form-group row" style="margin-bottom: 0px">
                    <label class="col-sm-3 control-label required-field font-normal">Location</label>
                    <div class="col-sm-8">
                      <div class="row form-group">
                        <div class="col-sm-6">
                          <select class="form-control input-sm" formControlName="country" type="text"
                            (keydown.enter)="$event.preventDefault()" (change)="onChangeCountry($event.target.value, i)"
                            placeholder="Country" [ngClass]="{
                              'is-invalid':
                                submit && locationSubmit &&
                                getLocationFormgroup(i).controls['country']
                                  .value
                            }">
                            <option selected disabled value="">Country</option>
                            <!-- <option value="null" selected disabled>Country</option> -->
                            <option *ngFor="let country of countryList" [value]="country.countryCode">
                              {{ country.countryName }}
                            </option>
                          </select>
                          <div *ngIf="
                              submit &&
                              locationSubmit &&
                              !getLocationFormgroup(i).controls['country'].value
                            " class="error-msg">
                         
                            <div>Country is required</div>
                         
                          </div>
                          </div>
                        <div class="col-sm-6" *ngIf="
                            companyLocationDetails.value[i].country == 'US'
                          ">
                          <input type="text" maxlength="12" (keydown.enter)="$event.preventDefault()"
                            placeholder="Zipcode" formControlName="zipCode" class="form-control input-sm"
                            (keydown.enter)="$event.preventDefault()" (keyup)="onKeyZip($event, i)" [ngClass]="{
                              'is-invalid':
                                submit && locationSubmit &&
                                getLocationFormgroup(i).controls['zipCode']
                                  .invalid
                            }" />
                          <div *ngIf="
                              companyLocationDetails.value[i].country == 'US' &&
                              ((submit && locationSubmit &&
                                getLocationFormgroup(i).controls['zipCode']
                                  .hasError) ||
                                (getLocationFormgroup(i).controls['zipCode']
                                  .hasError &&
                                  (getLocationFormgroup(i).controls['zipCode']
                                    .dirty ||
                                    getLocationFormgroup(i).controls['zipCode']
                                      .touched)))
                            " class="error-msg">
                            <div *ngIf="
                                getLocationFormgroup(i).controls[
                                  'zipCode'
                                ].hasError('required')
                              ">
                              Zipcode is required
                            </div>
                            <div *ngIf="
                                getLocationFormgroup(i).controls[
                                  'zipCode'
                                ].hasError('minword')
                              ">
                              {{FORMERROR.ZIPCODE_MIN}}
                            </div>
                            <div *ngIf="
                                getLocationFormgroup(i).controls[
                                  'zipCode'
                                ].hasError('maxword')
                              ">
                              {{FORMERROR.ZIPCODE_MAX}}
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-6" *ngIf="
                            companyLocationDetails.value[i].country == 'CA'
                          ">
                          <select class="form-control input-sm" formControlName="state" type="text"
                            (keydown.enter)="$event.preventDefault()" [ngClass]="{
                              'is-invalid':
                                submit && locationSubmit &&
                                getLocationFormgroup(i).controls['state']
                                  .invalid
                            }">
                            <option value="null" selected disabled>
                              State
                            </option>
                            <option *ngFor="let state of stateListCA" [value]="state.stateName">
                              {{ state.stateName }}
                            </option>
                          </select>

                          <div *ngIf="
                              companyLocationDetails.value[i].country == 'CA' &&
                              ((submit && locationSubmit &&
                                getLocationFormgroup(i).controls['state']
                                  .hasError) ||
                                (getLocationFormgroup(i).controls['state']
                                  .hasError &&
                                  (getLocationFormgroup(i).controls['state']
                                    .dirty ||
                                    getLocationFormgroup(i).controls['state']
                                      .touched)))
                            " class="error-msg">
                            <div *ngIf="
                                getLocationFormgroup(i).controls[
                                  'state'
                                ].hasError('required')
                              ">
                              State is required
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-6" *ngIf="
                            companyLocationDetails.value[i].country == 'IN'
                          ">
                          <select class="form-control input-sm" formControlName="state" type="text"
                            (keydown.enter)="$event.preventDefault()" [ngClass]="{
                              'is-invalid':
                                submit && locationSubmit &&
                                getLocationFormgroup(i).controls['state']
                                  .invalid
                            }">
                            <option value="null" selected disabled>
                              State
                            </option>
                            <option *ngFor="let state of stateListIN" [value]="state.stateName">
                              {{ state.stateName }}
                            </option>
                          </select>

                          <div *ngIf="
                              companyLocationDetails.value[i].country == 'IN' &&
                              ((submit && locationSubmit &&
                                getLocationFormgroup(i).controls['state']
                                  .hasError) ||
                                (getLocationFormgroup(i).controls['state']
                                  .hasError &&
                                  (getLocationFormgroup(i).controls['state']
                                    .dirty ||
                                    getLocationFormgroup(i).controls['state']
                                      .touched)))
                            " class="error-msg">
                            <div *ngIf="
                                getLocationFormgroup(i).controls[
                                  'state'
                                ].hasError('required')
                              ">
                              State is required
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-6" *ngIf="
                            companyLocationDetails.value[i].country == 'AU'
                          ">
                          <select class="form-control input-sm" formControlName="state" type="text"
                            (keydown.enter)="$event.preventDefault()" [ngClass]="{
                              'is-invalid':
                                submit && locationSubmit &&
                                getLocationFormgroup(i).controls['state']
                                  .invalid
                            }">
                            <option value="null" selected disabled>
                              State
                            </option>
                            <option *ngFor="let state of stateListAU" [value]="state.stateName">
                              {{ state.stateName }}
                            </option>
                          </select>

                          <div *ngIf="
                              companyLocationDetails.value[i].country == 'AU' &&
                              ((submit && locationSubmit &&
                                getLocationFormgroup(i).controls['state']
                                  .hasError) ||
                                (getLocationFormgroup(i).controls['state']
                                  .hasError &&
                                  (getLocationFormgroup(i).controls['state']
                                    .dirty ||
                                    getLocationFormgroup(i).controls['state']
                                      .touched)))
                            " class="error-msg">
                            <div *ngIf="
                                getLocationFormgroup(i).controls[
                                  'state'
                                ].hasError('required')
                              ">
                              State is required
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-6" *ngIf="
                            companyLocationDetails.value[i].country != 'AU' &&
                            companyLocationDetails.value[i].country != 'IN' &&
                            companyLocationDetails.value[i].country != 'CA' &&
                            companyLocationDetails.value[i].country != 'US'
                          ">
                          <input type="text" maxlength="51" (keydown.enter)="$event.preventDefault()"
                            placeholder="State" formControlName="state" class="form-control input-sm" [ngClass]="{
                              'is-invalid':
                                submit && locationSubmit &&
                                getLocationFormgroup(i).controls['state']
                                  .invalid
                            }" />
                          <div *ngIf="
                              companyLocationDetails.value[i].country != 'AU' &&
                              companyLocationDetails.value[i].country != 'IN' &&
                              companyLocationDetails.value[i].country != 'CA' &&
                              companyLocationDetails.value[i].country != 'US' &&
                              submit &&
                              locationSubmit &&
                              !getLocationFormgroup(i).controls['state'].value
                            " class="error-msg">
                            <div>State is required</div>
                         
                            <div *ngIf="getLocationFormgroup(i).controls['state'].hasError('maxword')">
                              {{FORMERROR.STATE_MAX}}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row form-group">
                        <div class="col-sm-6" *ngIf="
                            companyLocationDetails.value[i].country == 'US'
                          ">
                          <input disabled type="text" maxlength="51" (keydown.enter)="$event.preventDefault()"
                            placeholder="City" formControlName="city" class="form-control input-sm" [ngClass]="{
                              'is-invalid':
                                submit && locationSubmit &&
                                getLocationFormgroup(i).controls['city']
                                  .invalid
                            }" />
                          <div *ngIf="
                              (submit && locationSubmit &&
                                getLocationFormgroup(i).controls['city']
                                  .hasError) ||
                              (getLocationFormgroup(i).controls['city']
                                .hasError &&
                                (getLocationFormgroup(i).controls['city']
                                  .dirty ||
                                  getLocationFormgroup(i).controls['city']
                                    .touched))
                            " class="error-msg">
                            <div *ngIf="
                                getLocationFormgroup(i).controls[
                                  'city'
                                ].hasError('required')
                              ">
                              City is required
                            </div>
                            <div *ngIf="
                                getLocationFormgroup(i).controls['city'].hasError('maxword') ">
                              <div class="city-max"></div>
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-6" *ngIf="
                            companyLocationDetails.value[i].country != 'US'
                          ">
                          <input type="text" maxlength="51" (keydown.enter)="$event.preventDefault()" placeholder="City"
                            formControlName="city" class="form-control input-sm" [ngClass]="{
                              'is-invalid':
                                submit && locationSubmit &&
                                !getLocationFormgroup(i).controls['city']
                                  .value
                            }" />
                          <div *ngIf="
                              submit &&
                              locationSubmit &&
                              !getLocationFormgroup(i).controls['city'].value
                            " class="error-msg">
                         
                            <div>City is required</div>
                         
                            <div *ngIf="getLocationFormgroup(i).controls['city'].hasError('maxword')">
                              <div class="city-max"></div>
                            </div>
                          </div>
                        </div>

                        <div *ngIf="
                            companyLocationDetails.value[i].country != 'US'
                          " class="col-sm-6">
                          <input type="text" maxlength="12" (keypress)="digitKeyOnly($event)"
                            (keydown.enter)="$event.preventDefault()" placeholder="Zipcode" formControlName="zipCode"
                            class="form-control input-sm" (keydown.enter)="$event.preventDefault()" [ngClass]="{
                              'is-invalid':
                                submit && locationSubmit &&
                                getLocationFormgroup(i).controls['zipCode']
                                  .value
                            }" />
                          <div *ngIf="
                               submit &&
                              locationSubmit &&
                              !getLocationFormgroup(i).controls['zipCode'].value
                            " class="error-msg">
                            <div>Zipcode is required</div>
                            <div *ngIf="
                                getLocationFormgroup(i).controls[
                                  'zipCode'
                                ].hasError('pattern')
                              ">
                              Please enter only numbers
                            </div>
                            <div *ngIf="getLocationFormgroup(i).controls['zipCode'].hasError('minword')">
                              <div class="zip-min"></div>
                            </div>
                            <div *ngIf="getLocationFormgroup(i).controls['zipCode'].hasError('maxword')">
                              <div class="zip-max"></div>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6" *ngIf="
                            companyLocationDetails.value[i].country == 'US'
                          ">
                          <input disabled type="text" maxlength="51" placeholder="State" formControlName="state"
                            class="form-control input-sm" [ngClass]="{
                              'is-invalid':
                                submit && locationSubmit &&
                                getLocationFormgroup(i).controls['state']
                                  .invalid
                            }" />
                          <div *ngIf="
                              (submit && locationSubmit &&
                                getLocationFormgroup(i).controls['state']
                                  .hasError) ||
                              (getLocationFormgroup(i).controls['state']
                                .hasError &&
                                (getLocationFormgroup(i).controls['state']
                                  .dirty ||
                                  getLocationFormgroup(i).controls['state']
                                    .touched))
                            " class="error-msg">
                            <div *ngIf="
                                getLocationFormgroup(i).controls[
                                  'state'
                                ].hasError('required')
                              ">
                              State is required
                            </div>
                            <div *ngIf="
                                getLocationFormgroup(i).controls[
                                  'state'
                                ].hasError('maxword')
                              ">
                              {{FORMERROR.STATE_MAX}}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="row form-group">
                        <div class="col-sm-12">
                          <input type="text" placeholder="Landmark (Optional)" (keydown.enter)="$event.preventDefault()"
                            trim="blur" formControlName="street" class="form-control input-sm" />
                           [ngClass]="{ 'is-invalid': submit && locationSubmit && getLocationFormgroup(i).controls['street'].hasError}" -->
                      <!-- <small id="helpId" class="form-text text-muted">(Street/ Road/ Nearby location)</small> -->
                      <!-- <div *ngIf="submit && locationSubmit && getLocationFormgroup(i).controls['street'].hasError ||
                                            getLocationFormgroup(i).controls['street'].hasError &&
                                            (getLocationFormgroup(i).controls['street'].dirty || getLocationFormgroup(i).controls['street'].touched)"
                                                        class="error-msg">
                                                        <div
                                                            *ngIf="getLocationFormgroup(i).controls['street'].hasError('required')">
                                                            Street is required</div>
                                                    </div>
                        </div>
                      </div> -->
                    </div>
                  </div>
                  <div class="form-group row" *ngIf="currentIndex == i || currentIndex == null">
                    <label class="col-sm-3 control-label font-normal">Headquarters</label>
                    <div class="col-sm-8">
                      <div class="custom-checkbox" title="Check this if this location is the headquarters">
                        <label class="checkbox-label font-normal" style="text-align: center">
                          <input type="checkbox" formControlName="headquarters" (change)="curOrg($event, i)"
                            name="headquarters" />
                          <span class="checkmark" style="top: -5px"></span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row" *ngIf="primaryIndex == i || primaryIndex == null">
                    <label class="col-sm-3 required-field control-label font-normal">Current Location</label>
                    <div class="col-sm-8">
                      <div class="custom-checkbox" title="Check this if you want to keep this location as primary">
                        <label class="checkbox-label font-normal" style="text-align: center">
                          <!-- <div style="display: inline-block;"> -->
                          <input type="checkbox" formControlName="primary" (change)="keepPrimary($event, i)"
                            name="primary" />
                          <small style="position: relative; top: -6px;">By checking Current Location, this location
                            will be shown to public as your primary address. Authentication codes will be sent to this
                            address, either through post or email.</small>
                          <!-- </div> -->
                          <span class="checkmark" style="top: -5px"></span>
                        </label>
                        <div style="position: relative; float: left; margin-left: 17px;" *ngIf="
                        (submit && locationSubmit &&
                          getLocationFormgroup(i).controls['primary']
                            .hasError) ||
                        (getLocationFormgroup(i).controls['primary']
                          .hasError &&
                          (getLocationFormgroup(i).controls['primary']
                            .dirty ||
                            getLocationFormgroup(i).controls['primary']
                              .touched))
                      " class="error-msg">
                          <div *ngIf="
                          getLocationFormgroup(i).controls[
                            'primary'
                          ].hasError('required')
                        ">
                            At least one current location is required
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="businessPhone" class="col-sm-3 required-field control-label font-normal">Business
                      Phone</label>
                    <div class="col-sm-8">
                      <input type="text" formControlName="businessPhone" (keydown.enter)="$event.preventDefault()"
                        maxlength="16" class="form-control input-sm" placeholder="Business Phone Number" [ngClass]="{
                          'is-invalid':
                            submit && locationSubmit &&
                            getLocationFormgroup(i).controls['businessPhone']
                              .invalid
                        }" />

                      <div class="error-msg" *ngIf="
                          (submit && locationSubmit &&
                            getLocationFormgroup(i).controls['businessPhone']
                              .hasError) ||
                          (getLocationFormgroup(i).controls['businessPhone']
                            .hasError &&
                            (getLocationFormgroup(i).controls['businessPhone']
                              .dirty ||
                              getLocationFormgroup(i).controls['businessPhone']
                                .touched))
                        ">
                        <div *ngIf="
                            getLocationFormgroup(i).controls[
                              'businessPhone'
                            ].hasError('minword')
                          ">
                          {{FORMERROR.BUSINESSPHONE_MIN}}
                        </div>
                        <div *ngIf="
                      getLocationFormgroup(i).controls[
                        'businessPhone'
                          ].hasError('pattern')
                        ">
                          {{FORMERROR.NUMBER_PATTERN}}
                        </div>
                        <div *ngIf="
                            getLocationFormgroup(i).controls[
                              'businessPhone'
                            ].hasError('maxword')
                          ">
                          {{FORMERROR.BUSINESSPHONE_MAX}}
                        </div>
                        <div *ngIf="
                            getLocationFormgroup(i).controls[
                              'businessPhone'
                            ].hasError('required')
                          ">
                          Business Phone is required
                        </div>
                      </div>

                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="website" class="col-sm-3 control-label required-field font-normal">Website</label>
                    <div class="col-sm-8">
                      <input type="text" formControlName="website" class="form-control input-sm"
                        (keydown.enter)="$event.preventDefault()" placeholder="Website" [ngClass]="{
                          'is-invalid':
                            submit && locationSubmit &&
                            getLocationFormgroup(i).controls['website'].invalid
                        }" />
                      <div *ngIf="
                          (submit && locationSubmit &&
                            getLocationFormgroup(i).controls['website']
                              .hasError) ||
                          (getLocationFormgroup(i).controls['website']
                            .hasError &&
                            (getLocationFormgroup(i).controls['website']
                              .dirty ||
                              getLocationFormgroup(i).controls['website']
                                .touched))
                        " class="error-msg">
                        <div *ngIf="
                            getLocationFormgroup(i).controls[
                              'website'
                            ].hasError('required')
                          ">
                          Website is required
                        </div>

                        <div *ngIf="
                            getLocationFormgroup(i).controls[
                              'website'
                            ].hasError('pattern')
                          ">
                          Please enter a valid website without spaces
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="businessEmail" class="col-sm-3 control-label required-field font-normal">Business
                      Email</label>
                    <div class="col-sm-8">
                      <input type="text" formControlName="businessEmail" disabled class="form-control input-sm"
                        placeholder="Business Email" (keydown.enter)="$event.preventDefault()" [ngClass]="{
                          'is-invalid':
                            submit && locationSubmit &&
                            getLocationFormgroup(i).controls['businessEmail']
                              .invalid
                        }" />
                      <div *ngIf="
                          (submit && locationSubmit &&
                            getLocationFormgroup(i).controls['businessEmail']
                              .hasError) ||
                          (getLocationFormgroup(i).controls['businessEmail']
                            .hasError &&
                            (getLocationFormgroup(i).controls['businessEmail']
                              .dirty ||
                              getLocationFormgroup(i).controls['businessEmail']
                                .touched))
                        " class="error-msg">
                        <div *ngIf="
                            getLocationFormgroup(i).controls[
                              'businessEmail'
                            ].hasError('required')
                          ">
                          Business Email is required
                        </div>
                        <div *ngIf="
                            getLocationFormgroup(i).controls[
                              'businessEmail'
                            ].hasError('email')
                          ">
                          Please enter a valid email ID
                        </div>
                        <div class="col-sm-12" *ngIf="
                            getLocationFormgroup(i).controls[
                              'businessEmail'
                            ].hasError('notSameDomain')
                          ">
                          Not a valid domain for a business page. Please contact the support.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr *ngIf="!lastItem" />
              </div>
            </div>
            <!-- <hr> -->
            <div class="row" [formGroup]="businessForm">
              <!-- <label class="col-sm-3 control-label  font-normal">Send Code Offline</label> -->
              <div class="col-sm-12">
                <!-- <div class="custom-checkbox">
                                    <label class="checkbox-label font-normal" style="text-align: center;">
                                        <input type="checkbox"
                                            (click)="codeOffline($event)" name="verificationType"
                                            formControlName="verificationType">
                                        <span class="checkmark" style="top: -5px;"></span>
                                    </label>
                                </div> -->
                <div class="custom-checkbox pull-right" style="padding-right: 40px">
                  <label class="checkbox-label font-bold" style="text-align: center; margin-top: -4px">Send Code Offline
                    <input type="checkbox" formControlName="offlineVerification" (click)="codeOffline($event)"
                      name="offlineVerification" />
                    <span class="checkmark" title="Check this receive code offine"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="hpanel gs-card" *ngIf="hCareFlag">
          <div class="panel-heading gs-card-headerhbuilt">
            <div>
              Service Options
            </div>
            <div class="panel-tools">
              <div class="custom-checkbox" style="margin-top: 5px">
                <label class="checkbox-label font-normal" style="text-align: center">
                  Not Applicable
                  <input type="checkbox" (click)="notApplicable($event)" [attr.aria-expanded]="!isCollapsed"
                    aria-controls="collapseBasic" />
                  <span title="Check if not applicable" class="checkmark"></span>
                </label>
              </div>
            </div>
            <!-- <label class="control-label padding-top-0 margin-bottom-5 margin-top-5">Service Options</label> -->
          </div>

          <div class="panel-body gs-card-bodygs-card-body" formArrayName="serviceOptions" id="collapseBasic" [collapse]="isCollapsed"
            [isAnimated]="true">
            <div *ngFor="let physician of physicianArray.controls; let i = index">
              <div [formGroupName]="i" id="collapseEvent" [isAnimated]="true" [collapse]="isCollapsed"
                (collapses)="collapses()" (expands)="expands()" (collapsed)="collapsed()" (expanded)="expanded()">
                <div class="form-group row">
                  <label for="accredition" class="col-sm-3 control-label font-normal">Accredition</label>
                  <div class="col-sm-8">
                    <!-- <input [typeahead]="accreditionValue" [typeaheadMinLength]="0"
                                     class="form-control input-sm" placeholder="Accredition"  formControlName="accredition"> -->
                    <div >
                      <ng-select [addTag]="true" [items]="accreditionValue" [multiple]="false" [closeOnSelect]="true"
                        [hideSelected]="true" dropdownPosition="bottom" placeholder="Accredition"
                        [(ngModel)]="seletedaccredition" formControlName="accredition">
                      </ng-select>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="serviceType" class="col-sm-3 control-label font-normal">Type of Services</label>
                  <div class="col-sm-8">
                    <div >
                      <ng-select [addTag]="true" [items]="serviceTypeList" [multiple]="true" [hideSelected]="false"
                        dropdownPosition="bottom" placeholder="Type of Services" [(ngModel)]="serviceSelectedItems"
                        formControlName="serviceType">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                          <div class="ng-select-checkbox-label">
                            <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                            <span class="ng-select-checkbox-text">{{item}}</span>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="insuranceAccepted" class="col-sm-3 control-label font-normal">Insurance Accepted</label>
                  <div class="col-sm-8">
                    <div >
                      <ng-select [addTag]="true" [items]="insuranceList" [multiple]="true" [hideSelected]="false"
                        dropdownPosition="bottom" placeholder="Insurance Accepted" [(ngModel)]="insuranceSelectedItems"
                        formControlName="insuranceAccepted">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                          <div class="ng-select-checkbox-label">
                            <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                            <span class="ng-select-checkbox-text">{{item}}</span>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="medicareCertified" class="col-sm-3 control-label font-normal">Medicare Certified</label>
                  <div class="col-sm-8">
                    <div class="row">
                      <div class="col-sm-2" style="padding-top: 4px">
                        <div class="custom-checkbox" style="margin-top: 5px">
                          <label class="checkbox-label font-normal" style="text-align: center">
                            Yes
                            <input type="radio" [value]="true" formControlName="medicareCertified"
                              name="medicareCertified" />
                            <span title="Check Working Days" class="checkmark"></span>
                          </label>
                        </div>
                      </div>

                      <div class="col-sm-2" style="padding-top: 4px">
                        <div class="custom-checkbox" style="margin-top: 5px">
                          <label class="checkbox-label font-normal" style="text-align: center">
                            No
                            <input type="radio" [value]="false" formControlName="medicareCertified"
                              name="medicareCertified" />
                            <span title="Check Working Days" class="checkmark"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="acceptingNewPatients" class="col-sm-3 control-label font-normal">Accepting New
                    Patients</label>
                  <div class="col-sm-8">
                    <div class="row">
                      <div class="col-sm-2" style="padding-top: 4px">
                        <div class="custom-checkbox" style="margin-top: 5px">
                          <label class="checkbox-label font-normal" style="text-align: center">
                            Yes
                            <input type="radio" [value]="true" formControlName="acceptingNewPatients"
                              name="acceptingNewPatients" />
                            <span title="Check Working Days" class="checkmark"></span>
                          </label>
                        </div>
                      </div>
                      <div class="col-sm-2" style="padding-top: 4px">
                        <div class="custom-checkbox" style="margin-top: 5px">
                          <label class="checkbox-label font-normal" style="text-align: center">
                            No
                            <input type="radio" [value]="false" formControlName="acceptingNewPatients"
                              name="acceptingNewPatients" />
                            <span title="Check Working Days" class="checkmark"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="privatePayAccepted" class="col-sm-3 control-label font-normal">Private Pay
                    Accepted</label>
                  <div class="col-sm-8">
                    <div class="row">
                      <div class="col-sm-2" style="padding-top: 4px">
                        <div class="custom-checkbox" style="margin-top: 5px">
                          <label class="checkbox-label font-normal" style="text-align: center">
                            Yes
                            <input type="radio" [value]="true" formControlName="privatePayAccepted"
                              name="privatePayAccepted" />
                            <span title="Check Working Days" class="checkmark"></span>
                          </label>
                        </div>
                      </div>
                      <div class="col-sm-2" style="padding-top: 4px">
                        <div class="custom-checkbox" style="margin-top: 5px">
                          <label class="checkbox-label font-normal" style="text-align: center">
                            No
                            <input type="radio" [value]="false" formControlName="privatePayAccepted"
                              name="privatePayAccepted" />
                            <span title="Check Working Days" class="checkmark"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="hpanel gs-card">
          <div class="panel-heading gs-card-headerhbuilt">
            <div>
              Social Presence
            </div>
            <div class="panel-tools"></div>
            <!-- <label class="control-label padding-top-0 margin-bottom-5 margin-top-5">Social Presence</label> -->
          </div>
          <div class="panel-body gs-card-bodygs-card-body">
            <div formArrayName="userSocialPresence">
              <div *ngFor="let task of socialPresenceArray.controls; let i = index">
                <div [formGroupName]="i">
                  <div class="form-group row">
                    <label for="linkedin" class="col-sm-3 font-light control-label">LinkedIn</label>
                    <div class="col-sm-8">
                      <input type="text" class="form-control input-sm" trim="blur"
                        (keydown.enter)="$event.preventDefault()" placeholder="LinkedIn" formControlName="linkedin" />
                      <div class="error-msg"
                        *ngIf="task.controls.linkedin.invalid && task.controls.linkedin.errors?.pattern">
                        {{FORMERROR.HTTP_VALID}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="twitter" class="col-sm-3 font-light control-label">X</label>
                    <div class="col-sm-8">
                      <input type="text" (keydown.enter)="$event.preventDefault()" trim="blur"
                        class="form-control input-sm" placeholder="X" formControlName="twitter" />
                      <div class="error-msg"
                        *ngIf="task.controls.twitter.invalid && task.controls.twitter.errors?.pattern">
                        {{FORMERROR.HTTP_VALID}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="twitter" class="col-sm-3 font-light control-label">Facebook</label>
                    <div class="col-sm-8">
                      <input type="text" (keydown.enter)="$event.preventDefault()" trim="blur"
                        class="form-control input-sm" placeholder="Facebook" formControlName="facebook" />
                      <div class="error-msg"
                        *ngIf="task.controls.facebook.invalid && task.controls.facebook.errors?.pattern">
                        {{FORMERROR.HTTP_VALID}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="blogURL" class="col-sm-3 font-light control-label">Blog</label>
                    <div class="col-sm-8">
                      <input type="text" (keydown.enter)="$event.preventDefault()" trim="blur"
                        class="form-control input-sm" placeholder="Blog" formControlName="blogURL" />
                      <div class="error-msg"
                        *ngIf="task.controls.blogURL.invalid && task.controls.blogURL.errors?.pattern">
                        {{FORMERROR.HTTP_VALID}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="alternamePageLink" class="col-sm-3 font-light control-label">Other Website</label>
                    <div class="col-sm-8">
                      <input type="text" class="form-control input-sm" trim="blur"
                        (keydown.enter)="$event.preventDefault()" placeholder="Other Website"
                        formControlName="alternamePageLink" />
                      <div class="error-msg"
                        *ngIf="task.controls.alternamePageLink.invalid && task.controls.alternamePageLink.errors?.pattern">
                        {{FORMERROR.HTTP_VALID}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="youtube" class="col-sm-3 font-light control-label">YouTube</label>
                    <div class="col-sm-8">
                      <input type="text" class="form-control input-sm" trim="blur"
                        (keydown.enter)="$event.preventDefault()" placeholder="YouTube" formControlName="youtube" />
                      <div class="error-msg"
                        *ngIf="task.controls.youtube.invalid && task.controls.youtube.errors?.pattern">
                        {{FORMERROR.HTTP_VALID}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="instagram" class="col-sm-3 font-light control-label">Instagram</label>
                    <div class="col-sm-8">
                      <input type="text" class="form-control input-sm" trim="blur"
                        (keydown.enter)="$event.preventDefault()" placeholder="Instagram" formControlName="instagram" />
                      <div class="error-msg"
                        *ngIf="task.controls.instagram.invalid && task.controls.instagram.errors?.pattern">
                        {{FORMERROR.HTTP_VALID}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="tiktok" class="col-sm-3 font-light control-label">TikTok</label>
                    <div class="col-sm-8">
                      <input type="text" class="form-control input-sm" trim="blur"
                        (keydown.enter)="$event.preventDefault()" placeholder="TikTok" formControlName="tiktok" />
                      <div class="error-msg"
                        *ngIf="task.controls.tiktok.invalid && task.controls.tiktok.errors?.pattern">
                        {{FORMERROR.HTTP_VALID}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="hpanel gs-card">
          <div class="panel-heading gs-card-headerhbuilt">
            Working Hours
          </div>
          <div class="panel-body gs-card-bodygs-card-body">
            <div formArrayName="workingHours">
              <div *ngFor="
                  let work of workingHourArray.controls;
                  let i = index;
                  let lastItem = last
                ">
                <div [formGroupName]="i">
                  <div class="form-group row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-2">
                      <div class="custom-checkbox" style="margin-top: 5px">
                        <label class="checkbox-label font-normal" style="text-align: center">
                          Monday

                          <input type="checkbox" (click)="doHours($event)" formControlName="monWorking"
                            name="monWorking" />

                          <span title="Check Working Days" class="checkmark"></span>
                        </label>
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <select formControlName="monFromTime" class="form-control input-sm" (change)="frmHr($event)"
                        [ngClass]="{
                          'is-invalid':
                            submit &&
                            getHourFormGroup(i).controls['monFromTime'].hasError
                        }">
                        <option [ngValue]="null" [disabled]="true">
                          Opens
                        </option>
                        <option *ngFor="let hour of hours" [value]="hour">
                          {{ hour }}
                        </option>
                      </select>
                      <div class="error-msg" *ngIf="
                          submit &&
                          getHourFormGroup(i).controls['monFromTime'].hasError
                        ">
                        <div *ngIf="
                            getHourFormGroup(i).controls[
                              'monFromTime'
                            ].hasError('required')
                          ">
                          Please fill this out
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <select formControlName="monToTime" class="form-control input-sm" (change)="toHr($event)"
                        [ngClass]="{
                          'is-invalid':
                            submit &&
                            getHourFormGroup(i).controls['monToTime'].hasError
                        }">
                        <option [ngValue]="null" [disabled]="true">
                          Closes
                        </option>
                        <option *ngFor="let hour of hours" [value]="hour">
                          {{ hour }}
                        </option>
                      </select>
                      <div class="error-msg" *ngIf="
                          submit &&
                          getHourFormGroup(i).controls['monToTime'].hasError
                        ">
                        <div *ngIf="
                            getHourFormGroup(i).controls['monToTime'].hasError(
                              'required'
                            )
                          ">
                          Please fill this out
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row" style="
                      margin-left: 199px;
                      margin-top: -6px;
                      margin-bottom: 14px;
                    " *ngIf="worktime">
                    <div class="custom-checkbox" style="margin-top: 5px">
                      <label class="checkbox-label font-normal" style="text-align: center">
                        Apply this schedule for all
                        <input type="checkbox" formControlName="applyAll" name="applyAll"
                          (change)="changeHours($event)" />
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </div>

                  <div class="form-group row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-2">
                      <div class="custom-checkbox" style="margin-top: 5px">
                        <label class="checkbox-label font-normal" style="text-align: center">
                          Tuesday
                          <input type="checkbox" formControlName="tueWorking" name="tueWorking"
                            (change)="tue($event)" />
                          <span title="Check Working Days" class="checkmark"></span>
                        </label>
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <select formControlName="tueFromTime" class="form-control input-sm" (change)="hrOtherDay($event)"
                        [ngClass]="{
                          'is-invalid':
                            submit &&
                            getHourFormGroup(i).controls['tueFromTime'].hasError
                        }">
                        <option [ngValue]="null" [disabled]="true">
                          Opens
                        </option>
                        <option *ngFor="let hour of hours" [value]="hour">
                          {{ hour }}
                        </option>
                      </select>
                      <div class="error-msg" *ngIf="
                          submit &&
                          getHourFormGroup(i).controls['tueFromTime'].hasError
                        ">
                        <div *ngIf="
                            getHourFormGroup(i).controls[
                              'tueFromTime'
                            ].hasError('required')
                          ">
                          Please fill this out
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <select formControlName="tueToTime" class="form-control input-sm" (change)="hrOtherDay($event)"
                        [ngClass]="{
                          'is-invalid':
                            submit &&
                            getHourFormGroup(i).controls['tueToTime'].hasError
                        }">
                        <option [ngValue]="null" [disabled]="true">
                          Closes
                        </option>
                        <option *ngFor="let hour of hours" [value]="hour">
                          {{ hour }}
                        </option>
                      </select>
                      <div class="error-msg" *ngIf="
                          submit &&
                          getHourFormGroup(i).controls['tueToTime'].hasError
                        ">
                        <div *ngIf="
                            getHourFormGroup(i).controls['tueToTime'].hasError(
                              'required'
                            )
                          ">
                          Please fill this out
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-2">
                      <div class="custom-checkbox" style="margin-top: 5px">
                        <label class="checkbox-label font-normal" style="text-align: center">
                          Wednesday
                          <input type="checkbox" (change)="wed($event)" formControlName="wedWorking"
                            name="wedWorking" />
                          <span title="Check Working Days" class="checkmark"></span>
                        </label>
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <select formControlName="wedFromTime" class="form-control input-sm" (change)="hrOtherDay($event)"
                        [ngClass]="{
                          'is-invalid':
                            submit &&
                            getHourFormGroup(i).controls['wedFromTime'].hasError
                        }">
                        <option [ngValue]="null" [disabled]="true">
                          Opens
                        </option>
                        <option *ngFor="let hour of hours" [value]="hour">
                          {{ hour }}
                        </option>
                      </select>
                      <div class="error-msg" *ngIf="
                          submit &&
                          getHourFormGroup(i).controls['wedFromTime'].hasError
                        ">
                        <div *ngIf="
                            getHourFormGroup(i).controls[
                              'wedFromTime'
                            ].hasError('required')
                          ">
                          Please fill this out
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <select formControlName="wedToTime" class="form-control input-sm" (change)="hrOtherDay($event)"
                        [ngClass]="{
                          'is-invalid':
                            submit &&
                            getHourFormGroup(i).controls['wedToTime'].hasError
                        }">
                        <option [ngValue]="null" [disabled]="true">
                          Closes
                        </option>
                        <option *ngFor="let hour of hours" [value]="hour">
                          {{ hour }}
                        </option>
                      </select>
                      <div class="error-msg" *ngIf="
                          submit &&
                          getHourFormGroup(i).controls['wedToTime'].hasError
                        ">
                        <div *ngIf="
                            getHourFormGroup(i).controls['wedToTime'].hasError(
                              'required'
                            )
                          ">
                          Please fill this out
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-2">
                      <div class="custom-checkbox" style="margin-top: 5px">
                        <label class="checkbox-label font-normal" style="text-align: center">
                          Thursday
                          <input type="checkbox" formControlName="thrWorking" name="thrWorking"
                            (change)="thu($event)" />
                          <span title="Check Working Days" class="checkmark"></span>
                        </label>
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <select formControlName="thrFromTime" class="form-control input-sm" (change)="hrOtherDay($event)"
                        [ngClass]="{
                          'is-invalid':
                            submit &&
                            getHourFormGroup(i).controls['thrFromTime'].hasError
                        }">
                        <option [ngValue]="null" [disabled]="true">
                          Opens
                        </option>
                        <option *ngFor="let hour of hours" [value]="hour">
                          {{ hour }}
                        </option>
                      </select>
                      <div class="error-msg" *ngIf="
                          submit &&
                          getHourFormGroup(i).controls['thrFromTime'].hasError
                        ">
                        <div *ngIf="
                            getHourFormGroup(i).controls[
                              'thrFromTime'
                            ].hasError('required')
                          ">
                          Please fill this out
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <select formControlName="thrToTime" class="form-control input-sm" (change)="hrOtherDay($event)"
                        [ngClass]="{
                          'is-invalid':
                            submit &&
                            getHourFormGroup(i).controls['thrToTime'].hasError
                        }">
                        <option [ngValue]="null" [disabled]="true">
                          Closes
                        </option>
                        <option *ngFor="let hour of hours" [value]="hour">
                          {{ hour }}
                        </option>
                      </select>
                      <div class="error-msg" *ngIf="
                          submit &&
                          getHourFormGroup(i).controls['thrToTime'].hasError
                        ">
                        <div *ngIf="
                            getHourFormGroup(i).controls['thrToTime'].hasError(
                              'required'
                            )
                          ">
                          Please fill this out
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-2">
                      <div class="custom-checkbox" style="margin-top: 5px">
                        <label class="checkbox-label font-normal" style="text-align: center">
                          Friday
                          <input type="checkbox" formControlName="friWorking" name="friWorking"
                            (change)="fri($event)" />
                          <span title="Check Working Days" class="checkmark"></span>
                        </label>
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <select formControlName="friFromTime" class="form-control input-sm" (change)="hrOtherDay($event)"
                        [ngClass]="{
                          'is-invalid':
                            submit &&
                            getHourFormGroup(i).controls['friFromTime'].hasError
                        }">
                        <option [ngValue]="null" [disabled]="true">
                          Opens
                        </option>
                        <option *ngFor="let hour of hours" [value]="hour">
                          {{ hour }}
                        </option>
                      </select>
                      <div class="error-msg" *ngIf="
                          submit &&
                          getHourFormGroup(i).controls['friFromTime'].hasError
                        ">
                        <div *ngIf="
                            getHourFormGroup(i).controls[
                              'friFromTime'
                            ].hasError('required')
                          ">
                          Please fill this out
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <select formControlName="friToTime" class="form-control input-sm" (change)="hrOtherDay($event)"
                        [ngClass]="{
                          'is-invalid':
                            submit &&
                            getHourFormGroup(i).controls['friToTime'].hasError
                        }">
                        <option [ngValue]="null" [disabled]="true">
                          Closes
                        </option>
                        <option *ngFor="let hour of hours" [value]="hour">
                          {{ hour }}
                        </option>
                      </select>
                      <div class="error-msg" *ngIf="
                          submit &&
                          getHourFormGroup(i).controls['friToTime'].hasError
                        ">
                        <div *ngIf="
                            getHourFormGroup(i).controls['friToTime'].hasError(
                              'required'
                            )
                          ">
                          Please fill this out
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-2">
                      <div class="custom-checkbox" style="margin-top: 5px">
                        <label class="checkbox-label font-normal" style="text-align: center">
                          Saturday
                          <input type="checkbox" formControlName="satWorking" name="satWorking"
                            (change)="sat($event)" />
                          <span title="Check Working Days" class="checkmark"></span>
                        </label>
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <select formControlName="satFromTime" class="form-control input-sm" (change)="hrOtherDay($event)"
                        [ngClass]="{
                          'is-invalid':
                            submit &&
                            getHourFormGroup(i).controls['satFromTime'].hasError
                        }">
                        <option [ngValue]="null" [disabled]="true">
                          Opens
                        </option>
                        <option *ngFor="let hour of hours" [value]="hour">
                          {{ hour }}
                        </option>
                      </select>
                      <div class="error-msg" *ngIf="
                          submit &&
                          getHourFormGroup(i).controls['satFromTime'].hasError
                        ">
                        <div *ngIf="
                            getHourFormGroup(i).controls[
                              'satFromTime'
                            ].hasError('required')
                          ">
                          Please fill this out
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <select formControlName="satToTime" class="form-control input-sm" (change)="hrOtherDay($event)"
                        [ngClass]="{
                          'is-invalid':
                            submit &&
                            getHourFormGroup(i).controls['satToTime'].hasError
                        }">
                        <option [ngValue]="null" [disabled]="true">
                          Closes
                        </option>
                        <option *ngFor="let hour of hours" [value]="hour">
                          {{ hour }}
                        </option>
                      </select>
                      <div class="error-msg" *ngIf="
                          submit &&
                          getHourFormGroup(i).controls['satToTime'].hasError
                        ">
                        <div *ngIf="
                            getHourFormGroup(i).controls['satToTime'].hasError(
                              'required'
                            )
                          ">
                          Please fill this out
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-2">
                      <div class="custom-checkbox" style="margin-top: 5px">
                        <label class="checkbox-label font-normal" style="text-align: center">
                          Sunday
                          <input type="checkbox" formControlName="sunWorking" (change)="sun($event)" name="sunWorking"
                            (change)="sun($event)" />
                          <span title="Check Working Days" class="checkmark"></span>
                        </label>
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <select formControlName="sunFromTime" class="form-control input-sm" (change)="hrOtherDay($event)"
                        [ngClass]="{
                          'is-invalid':
                            submit &&
                            getHourFormGroup(i).controls['sunFromTime'].hasError
                        }">
                        <option [ngValue]="null" [disabled]="true">
                          Opens
                        </option>
                        <option *ngFor="let hour of hours" [value]="hour">
                          {{ hour }}
                        </option>
                      </select>
                      <div class="error-msg" *ngIf="
                          submit &&
                          getHourFormGroup(i).controls['sunFromTime'].hasError
                        ">
                        <div *ngIf="
                            getHourFormGroup(i).controls[
                              'sunFromTime'
                            ].hasError('required')
                          ">
                          Please fill this out
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <select formControlName="sunToTime" class="form-control input-sm" (change)="hrOtherDay($event)"
                        [ngClass]="{
                          'is-invalid':
                            submit &&
                            getHourFormGroup(i).controls['sunToTime'].hasError
                        }">
                        <option [ngValue]="null" [disabled]="true">
                          Closes
                        </option>
                        <option *ngFor="let hour of hours" [value]="hour">
                          {{ hour }}
                        </option>
                      </select>
                      <div class="error-msg" *ngIf="
                          submit &&
                          getHourFormGroup(i).controls['sunToTime'].hasError
                        ">
                        <div *ngIf="
                            getHourFormGroup(i).controls['sunToTime'].hasError(
                              'required'
                            )
                          ">
                          Please fill this out
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="text-right">
          <button [routerLink]="['/landingPage/business']" type="button" routerLinkActive="router-link-active"
            style="line-height: 21px; border-radius: 3px" [disabled]="disavow" class="btn btn-default">
            Cancel
          </button>
          <button type="button" class="btn primary-btn" style="margin-left: 2%" [disabled]="disavow"
            (click)="save()">
            Submit
          </button>
        </div>

        <!-- <small> By submitting this form, you're agreeing to CareOnline's Terms of Service and acknowledge our Privacy Policy </small>  -->
        <!-- </div> -->
      </form>
    </div>
    <div class="col-sm-3 ksdjh" [class.sticktherecss]="businessmenustick" #businessmenusticky>

      <app-business-profile-complete
        [totalBusinessPercentage]="totalBusinessPercentage"  [isCreationMode]="true"></app-business-profile-complete>
      <!-- <app-common-widget [page]="'BUSINESS_CREATION'" [inputData]="'BUSINESS'"  ></app-common-widget> -->
    </div>
  </div>

  <div *ngIf="isModalShown" [config]="backdropConfig" (onHidden)="canceldata()" bsModal #autoShownModal="bs-modal"
    class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-auto-name">
    <div class="modal-dialog" style="border-radius: 5px !important">
      <div class="modal-content">
        <div class="common-header-flex">
          <div>Authorization Code</div>
          <button>
            <span class="common-close" (click)="canceldata()">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="padding: 15px 0px 0px 22px">
          <p>
            An authorization code has been sent to your business email address.
          </p>
          <br />
          <p>
            Please check your business email and enter the authorization code
            below. Note that the authorization code is only valid for 10 minutes.
          </p>
          <form [formGroup]="OTPConfirm" style="margin-bottom: 14px">
            <div class="app-form">
              <div class="row">
                <div class="form-group">
                  <div class="col-sm-8">
                    <input formControlName="otp" placeholder="Enter code here" (keydown)="enterOtp()"
                      class="form-control input-sm" />
                    <div class="error-msg" *ngIf="
                        (disable && otpControl.otp.invalid) ||
                        (otpControl.otp.invalid &&
                          (otpControl.otp.dirty || otpControl.otp.touched))
                      ">
                      <div *ngIf="otpControl.otp.errors.required">
                        Please enter the authorization code
                      </div>
                      <div *ngIf="otpControl.otp.errors.pattern">
                        Please remove whitespaces
                      </div>
                    </div>
                    <div class="error-msg">

                      <div *ngIf="otp">
                        Incorrect code. Please enter the right one
                      </div>

                      <div *ngIf="timeExpired && !exit" style="position: none !important">
                        Authorization code has expired. Please hit 'Request
                        another code'
                      </div>

                      <div *ngIf="exit" style="position: none !important">
                        Authorization code has expired.<br />
                        Please hit 'Cancel' & resubmit business form.
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <!-- <a role="button" class="disabled" *ngIf="!resentOTPCode">Request another code in {{ " " }}</a> -->
          <!-- <span *ngIf="!resentOTPCode">
            <countdown [config]="{ leftTime: 599, format: 'mm:ss' }"></countdown>
          </span> -->
          <!-- <div class="row" *ngIf="resentOTPCode">
            <div class="pull-left" style="margin-left: 16px">
              <div>
                <a role="button" *ngIf="!resendotp" (click)="anotherCode()">Request another code</a>
              </div>

              <p *ngIf="resendotp && !exit" class="text-danger">
                Another code has been sent to your business email address.
                Please enter the code.
              </p>
            </div>
          </div> -->

          <div class="row" *ngIf="resentOTPCode">
            <div class="pull-left" style="margin-left: 16px">
              <div>
                <a role="button" *ngIf="!resendotp" (click)="anotherCode()">Request another code</a>
              </div>

              <p *ngIf="resendotp && !exit" class="text-danger">
                Another code has been sent to your business email address.
                Please enter the code.
              </p>
            </div>
          </div>
        </div>

        <div class="row" style="margin-left: 400px; padding-bottom: 6px">
          <div class="col otp">
            <button style="margin-right: 5px" *ngIf="!otp" (click)="canceldata()" class="btn btn-default">
              Cancel
            </button>
            <button style="margin-right: 5px" *ngIf="otp" (click)="canceldata()" class="btn btn-default">
              Cancel
            </button>
            <button *ngIf="!otp" (click)="navigate()" [disabled]="!OTPConfirm.valid" class="btn primary-btn">
              Continue
            </button>
            <button *ngIf="otp" (click)="navigate()" [disabled]="!OTPConfirm.valid" class="btn primary-btn">
              Continue
            </button>
          </div>
        </div>

        <!-- </div> -->
      </div>
    </div>
  </div>

  <div *ngIf="postalCode" [config]="backdropConfig" (onHidden)="onHidden1()" bsModal #postalCodeModal="bs-modal"
    class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-auto-name">
    <div class="modal-dialog">
      <div class="modal-content">

        <div class="common-header-flex">
          <div> Authorization Code </div>
          <button>
            <span class="common-close" (click)="hideModal1()" aria-hidden="true">&times;</span>
          </button>
        </div>

        <hr style="margin-top: 0px" />
        <div class="modal-body" style="padding-top: 0px; padding-bottom: 0px">
          <p>
            GigSumo only uses business email addresses for verifying
            authorization code - given that the business email address should be
            on the same domain as the website domain of the business. Otherwise,
            we send the authorization code for the business page through postal
            delivery to your company's address. Once you have received the
            authorization code, please login to GigSumo and check for the
            Business Page that you signed up with 'Verify Offline' on the
            Business menu. Click 'Verify' on the business card shown. Enter the
            authentication code that you will receive through postal delivery.
            Click 'Continue'. Bingo! You're done.
          </p>

          <div class="row form-group">
            <div class="col otp">
              <button (click)="hideModal1()" class="btn primary-btn">
                Ok
              </button>
            </div>
          </div>
        </div>
        <!-- <div class="modal-footer"> -->
        <!-- </div> -->
      </div>
    </div>
  </div>

  <ng-template #alreadyExitsBusiness>
    <div class="modal fade hmodal-warning" id="myModal9" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
            <h4 class="modal-title">Modal title</h4>
            <small class="font-bold">Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.</small>
          </div>
          <div class="modal-body">
            <p>
              <strong>Lorem Ipsum is simply dummy</strong> text of the printing
              and typesetting industry. Lorem Ipsum has been the industry's
              standard dummy text ever since the 1500s, when an unknown printer
              took a galley of type and scrambled it to make a type specimen
              book. It has survived not only five centuries, but also the leap
              into electronic typesetting, remaining essentially unchanged.
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default w70" data-dismiss="modal">
              Close
            </button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- <div *ngIf="wrongTag" [config]="{ show: true }" (onHidden)="onHidden1()" bsModal #tagModal="bs-modal"
     class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-auto-name">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-auto-name" class="modal-title pull-left">Tags Taken</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="hideModal1()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>{{message}}{{" "}}Please choose a different tag</p>
      </div>
    </div>
  </div>
</div> -->

  <div *ngIf="wplaceModalShown" [config]="backdropConfig" (onHidden)="onHidden2()" bsModal
    #chooseBusinessModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-auto-name">
    <div class="modal-dialog">
      <div class="modal-content">
        <div style="margin-right: 2rem; margin-top: 1rem">
          <button type="button" style="font-size: 27px; margin-right: -8px;font-weight: 400;" class="close pull-right"
            aria-label="Close" (click)="onHidden2()">
            <span aria-hidden="true">&times;</span>
          </button>
          <h5 style="margin: 0px 0px 10px 14px; padding-top: 10px">
            Select Business Address
          </h5>
        </div>
        <hr style="margin-top: 0px" />
        <div class="modal-body" style="padding: 0px 0px 22px 22px">
          <p>
            Please select one of your organizations from the dropdown to choose
            your business address
          </p>
          <br />
          <div>
            <form [formGroup]="chooseBusiness">
              <div class="form-group col-sm-8">
                <input placeholder="Select Organization Name" class="form-control input-sm max-hight"
                  formControlName="address1" (input)="clear()" [typeahead]="organizationList"
                  (typeaheadOnSelect)="onselecte($event)" [typeaheadMinLength]="0" typeaheadOptionField="address1"
                  [typeaheadItemTemplate]="customItemTemplate" autocomplete="off" />

                <ng-template #customItemTemplate let-model="item" style="width: 41rem !important">
                  <span>
                    <strong style="font-size: 14px">
                      {{ model.address1 }}
                    </strong>
                    <br />
                    <!-- Italicized location details -->
                    <i>
                      <small>
                        {{ model.street
                        }}<span *ngIf="model.street">{{ ", " }}</span>
                        {{ model.city
                        }}<span *ngIf="model.city">{{ ", " }}</span>
                        {{ model.state
                        }}<span *ngIf="model.state">{{ ", " }}</span>
                        {{ model.zipCode
                        }}<span *ngIf="model.zipCode">{{ ", " }}</span>
                        {{ model.country }}
                      </small>
                    </i>
                  </span>
                </ng-template>

                <div class="er-pp" *ngIf="formValidity && controlOfForms.address1.errors">
                  <div *ngIf="controlOfForms.address1.errors.required">
                    Please choose one business address
                  </div>
                </div>
              </div>
            </form>

            <div class="row">
              <div class="rowchange">
                <button style="margin-right: 5px" (click)="onHidden2()" class="btn secondary-btn float">
                  Cancel
                </button>
                <button (click)="patchThem()" style="margin-right: 10px" class="btn primary-btn float">
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
